<template>
  <div class="layout">
    <aside class="sidebar">
      <div class="top-icons">
        <!-- <button class="icon-btn">
            <img :src="logoImg" class="brand-logo" />
          </button> -->
        <!-- <button class="grid-btn" title="Apps">
          
          
        </button> -->


        <router-link to="/manager/bots" class="icon-link">
          <button class="icon-btn">
            <Workflow :size="18" />
          </button>
        </router-link>

        <router-link to="/manager/dashboard" class="icon-link">
          <button class="icon-btn">
            
            <LayoutDashboard :size="18" />
            <!-- <span>Dashboard</span> -->

            <!-- <PanelLeft :size="18" /> -->
          
          </button>
        </router-link>
      </div>

      <div class="bottom-icons">
        <div class="avatar">
          {{ userInitials }}
        </div>
        <button class="icon-btn">◐</button>
      </div>
    </aside>

    <div class="main-area">
      <header class="top">
        <div>
          <b>Manager Portal</b>
          <small> — {{ user?.username }} ({{ user?.role }})</small>
        </div>
        <div class="actions">
          <button @click="refreshAll">Refresh</button>
          <button class="logout" @click="logout">Logout</button>
          <!-- <button @click="$router.push('/manager/bots')">Flows</button> -->
        </div>
      </header>

      <main>
        <!-- Header -->
         <div class="ds_mainContent ds_mobileMainContent">
          <div class="sds_mainContent sds_mobileMainContent">
            <div class="ds_mainContent">

              <!-- Header -->
              <div class="ds_header_container">
                <div class="ds_header_title">
                  <h1>WhatsApp Business Chat Dashboard</h1>
                  <p>Manage your chats here.</p>
                </div>
                <div class="ds_filters">
                  <div style="position: relative; display: flex; align-items: center;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#25D366" xmlns="http://www.w3.org/2000/svg"
                      style="position: absolute; left: 10px; pointer-events: none;">
                      <path
                        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.149-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.94 3.659 1.437 5.63 1.438h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
                    </svg>
                    <select style="appearance: none; padding-left: 32px; padding-right: 32px; width: 150px;">
                      <option>Whatsapp</option>
                    </select>
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round"
                      style="position: absolute; right: 12px; top: 12px; pointer-events: none; color: #64748b;">
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </div>
                  <input type="text" placeholder="From Date" onfocus="(this.type='date')" onblur="(this.type='text')"
                    style="width: 130px;">
                  <input type="text" placeholder="To Date" onfocus="(this.type='date')" onblur="(this.type='text')"
                    style="width: 130px;">
                  <button class="ds_search_btn">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                      stroke-linecap="round" stroke-linejoin="round">
                      <circle cx="11" cy="11" r="8" />
                      <path d="m21 21-4.3-4.3" />
                    </svg>
                  </button>
                </div>
              </div>

              <!-- Stats Grid -->
              <div class="ds_stats_grid">
                <div class="stat_card active">
                  <div class="label">Active Chats</div>
                  <div class="value">{{ stats.active_chat }}</div>
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                  </svg>
                </div>
                <!-- {{ stats }} -->
                <div class="stat_card">
                  <div class="label">Chats in Queue</div>
                  <div class="value">{{ stats.queue_chat }}</div>
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                  </svg>
                </div>
                <div class="stat_card">
                  <div class="label">Agent Ready</div>
                  <div class="value">{{ stats.agent_ready }}</div>
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
                <div class="stat_card">
                  <div class="label">Avg. Wait Time</div>
                  <div class="value">1 min</div>
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
                <div class="stat_card">
                  <div class="label">CSAT Rating</div>
                  <div class="value">0</div>
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" style="color: #f59e0b; opacity: 1;">
                    <polygon
                      points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                  </svg>
                </div>
                <div class="stat_card">
                  <div class="label">IDLE Time</div>
                  <div class="value">1 min</div>
                  <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" style="color: #3b82f6; opacity: 1;">
                    <circle cx="12" cy="12" r="10" />
                    <polyline points="12 6 12 12 16 14" />
                  </svg>
                </div>
              </div>

              <!-- Panels Row -->
              <div class="ds_panel_row">
                <!-- Agent Status -->
                <div class="panel">
                  <div class="panel_header">Agent Status Panel</div>
                  <table class="ds_table">
                    <thead>
                      <tr>
                        <th>Agent Name</th>
                        <th>Status</th>
                        <th>Active Chats</th>
                      </tr>
                    </thead>
                    <!-- {{ agents }} -->
                    <tbody>
                        <tr v-for="agent in agents" :key="agent.id">
                        <td>{{ agent.username }}</td>
                        <td>
                          <span
                              class="status_badge"
                              :class="(agent.state === 'LIVE' || agent.state === 'READY') 
                                ? 'status_ready' 
                                : 'status_break'"
                            >
                              {{ agent.state }}
                            </span>
                            
                        </td>
                        <td><span class="active_chats_count">{{ agent.active_chats }}</span></td>
                      </tr>
                    
                      
                      
                    </tbody>
                  </table>
                </div>

                <!-- Activity Feed -->
                <div class="panel">
                  <div class="panel_header">Recent Chats / Activity Feed</div>
                  <div class="activity_list">
                    <div class="activity_item">
                      <div class="activity_icon" style="background: #eff6ff; color: #3b82f6;">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                          <circle cx="12" cy="7" r="4" />
                        </svg>
                      </div>
                      <div class="activity_content">
                        <p class="activity_text">Chat assigned to Rahul</p>
                        <p class="activity_time">2 minutes ago</p>
                      </div>
                    </div>
                    <div class="activity_item">
                      <div class="activity_icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M5 12h14" />
                          <path d="M12 5v14" />
                        </svg>
                      </div>
                      <div class="activity_content">
                        <p class="activity_text">Customer joined queue</p>
                        <p class="activity_time">5 minutes ago</p>
                      </div>
                    </div>
                    <div class="activity_item">
                      <div class="activity_icon" style="background: #ecfdf5; color: #10b981;">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      </div>
                      <div class="activity_content">
                        <p class="activity_text">Chat closed by Amit</p>
                        <p class="activity_time">8 minutes ago</p>
                      </div>
                    </div>
                    <div class="activity_item">
                      <div class="activity_icon" style="background: #fffbeb; color: #f59e0b;">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <polygon
                            points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      </div>
                      <div class="activity_content">
                        <p class="activity_text">Feedback received ★★★★★</p>
                        <p class="activity_time">12 minutes ago</p>
                      </div>
                    </div>
                    <div class="activity_item">
                      <div class="activity_icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                          stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                          <polyline points="14 2 14 8 20 8" />
                        </svg>
                      </div>
                      <div class="activity_content">
                        <p class="activity_text">New customer inquiry</p>
                        <p class="activity_time">Just now</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Live Queue Panel -->
              <div class="panel">
                <div class="panel_header">Live Queue Panel</div>
                <!-- {{ queueList }} -->
                <table class="ds_table">
                  <thead>
                    <tr>
                      <th>Customer Name</th>
                      <th>Customer Phone</th>
                      <th>Waiting Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="queue in queueList" :key="queue.id">
                      <td>{{ queue.name }}</td>
                      <td>{{ queue.phone }}</td>
                      <td><span class="time_badge time_good">{{ formatTime(queue.wait_seconds) }}</span></td>
                      <td><span class="status_waiting">Waiting</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { Workflow } from 'lucide-vue-next'

import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import { auth } from "@/services/auth";
import VARS from "@/services/vars";
// import StoryCard from "@/components/StoryCard.vue";
// import ConversationCard from "@/components/ConversationCard.vue";
// import logoImg from "@/assets/images/logo.png";
import { LayoutDashboard } from "lucide-vue-next";


const API_BASE = VARS.API_URL;
const router = useRouter();
const user = ref(auth.user);

const stats = ref({
  active_chat: 0,
  queue_chat: 0,
  agent_ready: 0
});

const userInitials = computed(() => {
  const name = user.value?.username || "U";
  return name
    .split(" ")
    .map(v => v[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
});

const agents = ref([]);
const agentsdata = ref([]);
const conversations = ref([]);
const queueList = ref([]);
const filter = ref("OPEN");

function logout() {
  auth.clear();
  router.push("/");
}

async function apiGet(path) {
  const r = await fetch(API_BASE + path, {
    headers: { Authorization: "Bearer " + auth.token },
  });

  if (r.status === 401) {
    logout();
    throw new Error("401");
  }

  const data = await r.json();
  if (!data.ok) throw new Error(data.message || "API_ERROR");
  return data;
}


async function loadAgents() {
  const data = await apiGet("/api/manager/agents");
  agentsdata.value = data.agents || [];
}

async function loadConversations() {
  const data = await apiGet(`/api/manager/conversations?filter=${filter.value}`);
  conversations.value = data.conversations || [];
}

async function refreshAll() {
  await loadAgents();
  await loadConversations();
}

// async function setFilter(v) {
//   filter.value = v;
//   await loadConversations();
// }

// async function assign(conversationId) {
//   const agentId = assignTo.value[conversationId];
//   if (!agentId) return;

//   await apiPost(`/api/manager/conversation/${conversationId}/assign`, {
//     agentId: Number(agentId),
//   });

//   await refreshAll();
// }

// async function closeConv(conversationId) {
//   await apiPost(`/api/manager/conversation/${conversationId}/close`, {});
//   await refreshAll();
// }

// async function openReadOnlyChat(conv) {
//   activeConversation.value = conv;
//   chatModalOpen.value = true;
//   chatLoading.value = true;
//   chatMessages.value = [];

//   try {
//     const data = await apiGet(`/api/manager/conversation/${conv.conversation_id}/messages`);
//     chatMessages.value = data.messages || [];
//   } catch (e) {
//     console.error("Failed to load messages", e);
//     chatMessages.value = [];
//   } finally {
//     chatLoading.value = false;
//   }
// }

// function closeReadOnlyChat() {
//   chatModalOpen.value = false;
//   activeConversation.value = null;
//   chatMessages.value = [];
// }

// function messageSender(m) {
//   if (m.sender_type === "AGENT") return m.sender_name || "Agent";
//   if (m.sender_type === "VISITOR") return "Visitor";
//   if (m.sender_type === "BOT") return "Bot";
//   return m.sender_type || "System";
// }

// function messageClass(m) {
//   if (m.sender_type === "AGENT") return "agentMsg";
//   if (m.sender_type === "VISITOR") return "visitorMsg";
//   if (m.sender_type === "BOT") return "botMsg";
//   return "systemMsg";
// }

// function formatTime(v) {
//   if (!v) return "";
//   try {
//     return new Date(v).toLocaleString();
//   } catch {
//     return v;
//   }
// }

async function loadManagerQueue() {
  try {
    const res = await apiGet(`/api/manager/queue-list`, {
      headers: {
        Authorization: `Bearer ${auth.token}`,
      },
    });

    const data = await res;

    if (data.ok) {
      console.log(data)
      queueList.value = data.data || [];
    }
  } catch (err) {
    console.error("loadManagerQueue error", err);
  }
}


function formatTime(seconds) {
  seconds = Number(seconds) || 0;

  if (seconds < 60) {
    return `${seconds}s`;
  }

  const mins = Math.floor(seconds / 60);
  if (mins < 60) {
    return `${mins}m ${seconds % 60}s`;
  }

  const hrs = Math.floor(mins / 60);
  const remainingMins = mins % 60;

  return `${hrs}h ${remainingMins}m`;
}

async function loadDashboard() {
  const res = await apiGet("/api/manager/agent-status", {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  });

  const data = await res;
  

  if (data.ok) {
    agents.value = data.data;
    console.log("data", data);
  }
}




async function loadStats() {
  const res = await apiGet(`/api/manager/dashboard-stats`, {
    headers: {
      Authorization: `Bearer ${auth.token}`
    }
  });

  const data = await res;

  if (data.ok) {
    stats.value = data.data;
  }
}


onMounted(async () => {
  if (!auth.token) return router.push("/");
  if (!["admin", "manager"].includes(auth.user?.role)) return router.push("/inbox");
  await refreshAll();
  await loadDashboard();
  await loadManagerQueue();
  await loadStats();

  setInterval(() => {
      window.location.reload();

}, 5000);

});
</script>

<style scoped>
.layout {
  display: flex;
  min-height: 100vh;
  background: #f5f7fb;
  font-family: Arial, sans-serif;
}

.sidebar {
  width: 72px;
  min-width: 72px;
  background: #ffffff;
  border-right: 1px solid #e9edf3;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 14px 10px;
  box-sizing: border-box;
}

.top-icons,
.bottom-icons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.icon-link {
  text-decoration: none;
}

.grid-btn,
.icon-btn {
  width: 42px;
  height: 42px;
  border: 1px solid #dde3ec;
  border-radius: 12px;
  background: #fff;
  color: #222;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
  font-size: 18px;
}

.grid-btn:hover,
.icon-btn:hover {
  background: #f2f6ff;
  border-color: #cfdcff;
}

.icon-btn.active {
  background: #0b66d1;
  color: #fff;
  border-color: #0b66d1;
}

.grid-btn {
  display: grid;
  grid-template-columns: repeat(3, 4px);
  grid-template-rows: repeat(3, 4px);
  gap: 4px;
}

.grid-btn span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #333;
  display: block;
}

.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #0b66d1;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
}

.main-area {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 18px;
  border-bottom: 1px solid #e9edf3;
  background: #fff;
}

.actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

button {
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  background: #0b66d1;
  color: #fff;
  cursor: pointer;
}

button.logout {
  background: #444;
}

button.danger {
  background: #e74c3c;
}

button.secondary {
  background: #6c757d;
}

.grid {
  display: grid;
  grid-template-columns: 360px 1fr;
  gap: 12px;
  padding: 12px;
  flex: 1;
  min-height: 0;
}

.card {
  border: 1px solid #e9edf3;
  border-radius: 14px;
  overflow: hidden;
  background: #fff;
  min-height: 0;
}

.cardHead {
  padding: 10px 12px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

h3 {
  margin: 0;
}

.agents,
.convs {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: calc(100vh - 110px);
  overflow: auto;
}

.agent,
.conv {
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 12px;
  background: #fafafa;
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.tabs {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tab {
  background: #eee;
  color: #000;
}

.tab.on {
  background: #e6f0ff;
  color: #0b66d1;
  border: 2px solid #0b66d1;
}

.preview {
  margin-top: 6px;
  font-size: 12px;
  color: #555;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

select {
  padding: 8px;
  border-radius: 10px;
  border: 1px solid #ccc;
}

.muted {
  color: #777;
  font-size: 12px;
}

.pill {
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid #ddd;
  font-size: 11px;
  background: #f5f5f5;
}

.pill.READY {
  background: #e9f6ee;
  border-color: #bfe6cc;
}
.pill.LIVE {
  background: #4fc77d;
  border-color: #abe4be;
  color: #fafafa;
}
.pill.AWAY {
  background: #fff5e6;
  border-color: #ffe0a3;
}
.pill.OFFLINE {
  background: #f5f5f5;
  border-color: #ddd;
}
.pill.OPEN {
  background: #e9f6ee;
  border-color: #bfe6cc;
}
.pill.CLOSED {
  background: #f5f5f5;
  border-color: #ddd;
}
.pill.QUEUED {
  background: #fff5e6;
  border-color: #ffe0a3;
}

.chatContainer {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 110px);
  background: #fff;
}

.chatHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  border-bottom: 1px solid #eee;
}

.messages {
  flex: 1;
  overflow-y: auto;
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #f8f9fb;
}

.msg {
  max-width: 75%;
  border-radius: 12px;
  border: 1px solid #ddd;
  background: white;
  margin-bottom: 10px;
}

.agentMsg {
  align-self: flex-end;
  background: #eaf3ff;
  border-color: #cfe0ff;
}

.visitorMsg {
  align-self: flex-start;
  background: #fff;
}

.botMsg {
  align-self: flex-end;
  background: #eefaf0;
  border-color: #cfead5;
}

.systemMsg {
  align-self: center;
  background: #f1f1f1;
  max-width: 90%;
}

.readOnlyBar {
  padding: 12px 14px;
  border-top: 1px solid #eee;
  background: #fafafa;
  color: #666;
  font-size: 13px;
  text-align: center;
}

.emptyState {
  height: calc(100vh - 110px);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #777;
  font-size: 14px;
}


.brand-logo {
  width: 40px;
}


@media (max-width: 900px) {
  .grid {
    grid-template-columns: 1fr;
  }

  .sidebar {
    width: 60px;
    min-width: 60px;
    padding: 10px 8px;
  }

  .grid-btn,
  .icon-btn,
  .avatar {
    width: 38px;
    height: 38px;
  }

  .top {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}



/* New Syle  */


:root {
      --primary: #3b82f6;
      --primary-dark: #2563eb;
      --bg: #f8fafc;
      --card-bg: #ffffff;
      --text-main: #1e293b;
      --text-muted: #64748b;
      --border: #e2e8f0;
      --success: #10b981;
      --warning: #f59e0b;
      --danger: #ef4444;
      --info: #3b82f6;
    }

    body {
      font-family: 'Archivo', sans-serif;
      background: #f8fafc;
      color: #1e293b;
      margin: 0;
      padding: 0;
    }
    

.ds_mainContent {
      padding: 10px;
      /* max-width: 90%; */
      xmargin: 0 auto;
    }

    /* Header & Filters */
    .ds_header_container {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 24px;
    }

    .ds_header_title h1 {
      margin: 0;
      font-size: 24px;
      font-weight: 700;
      color: #1e293b;
    }

    .ds_header_title p {
      margin: 4px 0 0;
      color: #64748b;
      font-size: 14px;
    }

    .ds_filters {
      display: flex;
      gap: 12px;
      align-items: center;
    }

    .ds_filters select,
    .ds_filters input {
      padding: 0px 12px;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      font-size: 14px;
      color: #1e293b;
      background: white;
      outline: none;
      transition: border-color 0.2s;
    }

    .ds_filters select:focus,
    .ds_filters input:focus {
      border-color: #3b82f6;
    }

    .ds_search_btn {
      background: #3b82f6;
      color: white;
      border: none;
      padding: 10px;
      border-radius: 8px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s;
    }

    .ds_search_btn:hover {
      background: #2563eb;
    }

    /* Stats Grid */
    .ds_stats_grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 16px;
      margin-bottom: 24px;
    }

    .stat_card {
      background: #ffffff;
      padding: 20px;
      border-radius: 12px;
      border: 1px solid #e2e8f0;
      position: relative;
      transition: transform 0.2s, box-shadow 0.2s;
    }

    .stat_card:hover {
      transform: translateY(-4px);
      box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    }

    .stat_card.active {
      background: #3b82f6;
      color: white;
      border-color: #3b82f6;
    }

    .stat_card .label {
      font-size: 13px;
      font-weight: 500;
      margin-bottom: 8px;
      color: #64748b;
    }

    .stat_card.active .label {
      color: rgba(255, 255, 255, 0.8);
    }

    .stat_card .value {
      font-size: 24px;
      font-weight: 700;
      margin: 0;
    }

    .stat_card .icon {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 20px;
      height: 20px;
      opacity: 0.8;
    }

    /* Panels Layout */
    .ds_panel_row {
      display: grid;
      grid-template-columns: 2fr 1fr;
      gap: 24px;
      margin-bottom: 24px;
    }

    .panel {
      background: #ffffff;
      padding: 24px;
      border-radius: 12px;
      border: 1px solid #e2e8f0;
    }

    .panel_header {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 600;
      color: #1e293b;
    }

    /* Table Styling */
    .ds_table {
      width: 100%;
      border-collapse: collapse;
    }

    .ds_table th {
      text-align: left;
      padding: 12px 16px;
      font-size: 12px;
      text-transform: uppercase;
      color: #64748b;
      font-weight: 600;
      border-bottom: 1px solid #e2e8f0;
    }

    .ds_table td {
      padding: 16px;
      font-size: 14px;
      border-bottom: 1px solid #f1f5f9;
    }

    .ds_table tr:last-child td {
      border-bottom: none;
    }

    /* Badges */
    .status_badge {
      display: inline-flex;
      align-items: center;
      padding: 4px 12px;
      border-radius: 100px;
      font-size: 12px;
      font-weight: 500;
      gap: 6px;
    }

    .status_badge::before {
      content: '';
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }

    .status_ready {
      background: #ecfdf5;
      color: #059669;
    }

    .status_ready::before {
      background: #059669;
    }

    .status_live {
      background: #eff6ff;
      color: #2563eb;
    }

    .status_live::before {
      background: #2563eb;
    }

    .status_break {
      background: #fffbeb;
      color: #d97706;
    }

    .status_break::before {
      background: #d97706;
    }

    .active_chats_count {
      color: #3b82f6;
      font-weight: 600;
    }

    /* Activity Feed */
    .activity_list {
      list-style: none;
      padding: 0;
      margin: 0;
    }

    .activity_item {
      display: flex;
      gap: 16px;
      padding: 16px 0;
      border-bottom: 1px solid #f1f5f9;
    }

    .activity_item:last-child {
      border-bottom: none;
    }

    .activity_icon {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #f1f5f9;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #64748b;
      flex-shrink: 0;
    }

    .activity_content {
      flex: 1;
    }

    .activity_text {
      font-size: 14px;
      margin: 0;
      font-weight: 500;
    }

    .activity_time {
      font-size: 12px;
      color: #64748b;
      margin-top: 4px;
    }

    /* Queue Styles */
    .time_badge {
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;
    }

    .time_good {
      background: #ecfdf5;
      color: #059669;
    }

    .time_warning {
      background: #fff7ed;
      color: #c2410c;
    }

    .time_danger {
      background: #fef2f2;
      color: #dc2626;
    }

    .status_waiting {
      color: #f59e0b;
      font-weight: 600;
    }

    .ds_pageContainer {
      display: flex;
      height: 100vh;
      overflow: hidden;
    }

    #sidebar {
      width: 260px;
      height: 100vh;
      flex-shrink: 0;
      z-index: 20;
    }

    .ds_viewWrapper {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      height: 100vh;
      overflow: hidden;
    }

    #topbar {
      height: 54px;
      flex-shrink: 0;
      background: #fff;
      border-bottom: 1px solid #e2e8f0;
      position: relative;
      z-index: 10;
    }

    .ds_mainContent {
      padding: 10px !important;
      flex-grow: 1;
      background: #f8fafc;
      position: relative !important;
      top: 0px;
      left: 0dvb;
      overflow-y: auto;

    }

    .topbarLogo {
      height: 16px;
      padding: 0 0 1px 10px;
    }

    #sidebar {
      width: 66px;

    }
</style>